module.exports = __webpack_public_path__ + "static/media/double-downGreen.e942228c.svg";